// src/pages/MPFlow/components/targeting/InterestTagsInput.jsx
import React, { useState } from 'react';

const SUGGESTED_INTERESTS = [
  'Marketing digital', 'Empreendedorismo', 'E-commerce', 'Moda',
  'Fitness', 'Academia', 'Alimentação saudável', 'Culinária',
  'Tecnologia', 'Design', 'Fotografia', 'Viagens',
  'Beleza', 'Estética', 'Saúde', 'Yoga',
  'Restaurantes', 'Imóveis', 'Educação', 'Finanças',
  'Pets', 'Automóveis', 'Esportes', 'Games',
  'Música', 'Arte', 'Decoração', 'Sustentabilidade',
];

export default function InterestTagsInput({ value = [], onChange }) {
  const [query, setQuery] = useState('');

  const filtered = SUGGESTED_INTERESTS.filter(
    (i) => !value.includes(i) && i.toLowerCase().includes(query.toLowerCase())
  );

  const addInterest = (interest) => {
    if (!value.includes(interest)) {
      onChange([...value, interest]);
    }
    setQuery('');
  };

  const removeInterest = (interest) => {
    onChange(value.filter((i) => i !== interest));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && query.trim().length >= 2) {
      e.preventDefault();
      addInterest(query.trim());
    }
  };

  return (
    <div className="seg-interests">
      {/* Tags selecionadas */}
      {value.length > 0 && (
        <div className="seg-interests__tags">
          {value.map((tag) => (
            <span key={tag} className="seg-interests__tag">
              {tag}
              <button type="button" className="seg-interests__tag-x" onClick={() => removeInterest(tag)}>×</button>
            </span>
          ))}
        </div>
      )}

      {/* Input busca */}
      <input
        className="mp-field__input"
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Buscar ou digitar interesse..."
      />

      {/* Sugestões */}
      {query.length > 0 && filtered.length > 0 && (
        <div className="seg-interests__suggestions">
          {filtered.slice(0, 8).map((interest) => (
            <button
              key={interest}
              type="button"
              className="seg-interests__suggestion"
              onClick={() => addInterest(interest)}
            >
              + {interest}
            </button>
          ))}
        </div>
      )}

      {/* Sugestões rápidas quando vazio */}
      {query.length === 0 && value.length < 3 && (
        <div className="seg-interests__quick">
          <span className="seg-interests__quick-label">Sugestões:</span>
          {SUGGESTED_INTERESTS.filter((i) => !value.includes(i)).slice(0, 6).map((interest) => (
            <button
              key={interest}
              type="button"
              className="seg-interests__quick-btn"
              onClick={() => addInterest(interest)}
            >
              {interest}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
